import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import CommentOutlinedIcon from "@material-ui/icons/CommentOutlined";
import Button from "@material-ui/core/Button";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import instance from "../../../store/actions/instance";
import { v4 as uuidv4 } from "uuid";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

class SpecialRemarksFile extends Component {
  inputRef = React.createRef();
  state = {
    filename: this.props.specialRemarksFileName || undefined,
    errorOpen: false,
    errorMessage: "",
    errorMessageArabic: "",
  };

  handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const allowableExtensions = [
      "txt",
      "jpg",
      "jpeg",
      "bmp",
      "png",
      "doc",
      "docx",
      "odt",
      "pdf",
      "xls",
      "xlsx",
      "ods",
      "ppt",
      "pptx",
      "rar",
      "zip",
      "zipx",
      "7z",
      "csv",
      "mp3",
      "wav",
      "m4a",
      "flac",
      "aac",
      "ogg",
      "wma",
      "aiff",
      "aif",
      "ape",
      "midi",
      "mid",
      "amr",
      "ac3",
      "caf",
      "au",
    ];

    if (!allowableExtensions.includes(fileExtension)) {
      this.inputRef.current.value = "";
      this.setState({
        errorOpen: true,
        errorMessage: "Invalid file format",
        errorMessageArabic: "نوع الملف غير مدعم",
      });
      return;
    }

    if (file.size / 1024 / 1024 > 10) {
      this.inputRef.current.value = "";
      this.setState({
        errorOpen: true,
        errorMessage: "File must be smaller than 10 MB",
        errorMessageArabic: "حجم الملف يجب ان يكون أصغر من 10 ميجا",
      });
      return;
    }

    this.setState({ filename: file.name });
    let formData = new FormData();
    let uuid = uuidv4();
    let keys = [uuid];

    formData.append(`keys`, keys);
    formData.append(`file${uuid}`, file, file.name);
    formData.append(`store`, this.props.store.slug);
    try {
      let res = await instance.post(
        "https://proxy.ordable.com/upload_file/",
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );

      res.data.forEach((file) => {
        if (file.file_url) {
          this.props.setSpecialRemarksFiles(file.file_url, this.state.filename);
        }
      });
    } catch (err) {
      console.log(this.inputRef.current);
      this.inputRef.current.value = "";
      this.setState({
        errorOpen: true,
        filename: undefined,
        errorMessage: "Something went wrong. Please try again",
        errorMessageArabic: "حدث خطأ ما. الرجاء المحاولة مرة اخرى",
      });

      return "-1";
    }
  };
  removeFile = () => {
    this.inputRef.current.value = null;
    this.props.setSpecialRemarksFiles(null, null);
    this.setState({ filename: undefined });
  };
  handleErrorClose = () => {
    this.setState({ errorOpen: "" });
  };
  render() {
    const { customTexts, language, isB2B } = this.props;
    const { errorOpen, errorMessage, errorMessageArabic } = this.state;

    let label =
      language === "english"
        ? customTexts.special_remarks_files
        : customTexts.special_remarks_files_ar;
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {label}
        </p>
        <Snackbar
          style={{ bottom: 70 }}
          open={errorOpen}
          autoHideDuration={6000}
          onClose={this.handleErrorClose}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={this.handleErrorClose}
            severity="error"
          >
            {(language === "arabic" && errorMessageArabic) || errorMessage}
          </MuiAlert>
        </Snackbar>
        <div
          className="bordered"
          style={{
            backgroundColor: "white",
            minHeight: 80,
            maxHeight: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          <div>
            <CommentOutlinedIcon
              style={{
                color: "#5b5b5b",
              }}
            />
          </div>

          <div
            style={{
              position: "relative",
              width: "90%",
              top: (this.state.filename && -10) || -20,
            }}
          >
            <input
              ref={this.inputRef}
              id="fileInput"
              onChange={this.handleFileUpload}
              style={{ display: "none" }}
              multiple
              type="file"
            />
            <label
              className="pointer"
              htmlFor="fileInput"
              style={{
                width: "93%",
                position: "relative",
                top: 31,
                textAlign: language === "english" ? "left" : "right",
                zIndex: 0,
                right: language === "english" ? "3%" : "-3%",
              }}
            >
              <Button
                style={{ textTransform: "none", width: "95px" }}
                className="p-1 mb-2"
                variant="contained"
                color="primary"
                component="span"
              >
                {language === "english" ? "Choose file" : "إختار ملف"}
              </Button>
            </label>

            <TextField
              style={{ pointerEvents: "none" }}
              color="primary"
              fullWidth
              placeholder={language === "english" ? "Choose file" : "إختار ملف"}
              error={
                !this.state.filename &&
                this.props.settings.special_remarks_files_required
              }
              value={
                !this.state.filename &&
                this.props.settings.special_remarks_files_required
                  ? language === "arabic"
                    ? "هذه الخانة مطلوبة"
                    : "This field is required"
                  : this.state.filename || ""
              }
              InputLabelProps={{
                style: {
                  color: "red",
                  right: language == "arabic" && 5,
                  left: language == "english" ? 25 : 0,
                },
                dir: language == "english" ? "ltr" : "rtl",
              }}
              InputProps={{
                style:
                  language == "english"
                    ? {
                        color:
                          !this.state.filename &&
                          this.props.settings.special_remarks_files_required &&
                          "red",
                        paddingLeft: 105,
                      }
                    : {
                        color:
                          !this.state.filename &&
                          this.props.settings.special_remarks_files_required &&
                          "red",
                        paddingRight: 105,
                      },
                dir: language == "english" ? "ltr" : "rtl",
                inputProps: { style: { width: "90%" } },
              }}
            />
            {this.state.filename && (
              <DeleteForeverIcon
                className="pointer"
                width={25}
                height={25}
                onClick={() => this.removeFile()}
                style={{
                  position: "relative",
                  float: language === "english" ? "right" : "left",
                  bottom: 28,
                  cursor: "pointer",
                  color: "#ff4242",
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    customTexts: state.store.store.settings.custom_texts,
    store: state.store.store,
  };
};

export default connect(mapStateToProps)(SpecialRemarksFile);
